// extracted by mini-css-extract-plugin
module.exports = {"welcomeImage":"styles_welcomeImage__vQvw1"};